import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { REVIEW_QUEUE_KEY } from "./use-review-queue";

type BulkRetryIngestResult = components["schemas"]["BulkRetryIngestResult"];

/**
 * Re-drive every ingest-stage hold in one server-side sweep.
 * POST /v1/orders/bulk-retry-ingest (no request body).
 * Returns { attempted, locked, still_held, failed } — all required fields.
 * On settled: invalidates the review queue and the orders list.
 */
export function useBulkRetryIngest() {
  const queryClient = useQueryClient();
  return useMutation<BulkRetryIngestResult, Error>({
    meta: { silentError: true },
    mutationFn: async () => {
      const { data, error } = await apiClient.POST("/v1/orders/bulk-retry-ingest", {});
      if (error) throw error;
      return data as BulkRetryIngestResult;
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: REVIEW_QUEUE_KEY });
      void queryClient.invalidateQueries({ queryKey: ["orders"] });
    },
  });
}
